console.log("Global JS loaded.");

class ToggleItem extends HTMLElement {
    constructor() {
      super();
      this._toggle = this._toggle.bind(this);
      this.querySelector("div").style.height = this.classList.contains("actif")
        ? "auto"
        : "0px";
    }
  
    connectedCallback() {
      this.querySelector("h3, p").addEventListener("click", this._toggle);
    }
  
    disconnectedCallback() {
      this.querySelector("h3, p").removeEventListener("click", this._toggle);
    }
  
    _toggle() {
      const content = this.querySelector("div");
      this.classList.toggle("actif");
      const isActive = this.classList.contains("actif");
      content.style.height = !isActive ? "0px" : `${content.scrollHeight}px`;
    }
  }
customElements.define("toggle-item", ToggleItem);

function calcShipping() {
  document.querySelectorAll('#delivery-estimate').forEach(el => {
    const delay = parseInt(el.dataset.delay, 10);

    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + delay);

    const dow = deliveryDate.getDay();
    if (dow === 6) {
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    } else if (dow === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    const day     = deliveryDate.getDate();
    const month   = deliveryDate.toLocaleString('fr-FR', { month: 'long' });
    const weekday = deliveryDate.toLocaleString('fr-FR', { weekday: 'long' });

    const heading = el.textContent.trim();
    const message = `${weekday} ${day} ${month}`;

    el.innerHTML = `${heading} <span class="delivery-date p-medium fw-700">${message}</span>`;
  });
}

window.calcShipping = calcShipping;

document.addEventListener('DOMContentLoaded', calcShipping);
document.addEventListener('shopify:section:load', calcShipping);
